import { type ReactNode, type RefObject } from "react";
import { DropdownContainer } from "./Dropdown.styles";
export { DropdownRowButton } from "./Dropdown.styles";

interface DropdownProps {
  clickHandleRef?: RefObject<HTMLDivElement> | null;
  show: boolean;
  children: ReactNode;
}

export const Dropdown = ({ clickHandleRef, show, children }: DropdownProps) => (
  <DropdownContainer ref={clickHandleRef} show={show}>
    {children}
  </DropdownContainer>
);
